import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import Grid from '@mui/material/Grid';
import { findAllColors } from '../../../_events/color/find_colors.event';
import AutoSelect from '../../../containers/selects/auto_select';

const AutoSelectColors = (props) => {

    const [colors, setColors] = useState([]);

    useEffect(() => {
        findAllColors()
        .then(data => {
            setColors(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }, []);

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <input hidden id='order_color' />
                <input hidden id='order_color_ref' />
                <AutoSelect
                    id='order_color_autoselect'
                    label='Color'
                    getOptionLabel={(option) => `${option.cod} - ${option.description}`}
                    renderOption={(props, option) => (<div {...props}>{`${option.cod} - ${option.description}`}</div>)}
                    data={colors}
                    onChange = {(value) => {
                        document.getElementById('order_color').value = value ? value['uuid'] : '';
                        document.getElementById('order_color_ref').value = value ? value['cod'] :  '';
                    }}
                />
            </Grid>
        </Grid>
    );

}

export default AutoSelectColors;